module.exports = __webpack_public_path__ + "media/images/map/4-e1e1e7f820dfb7637ac2d6499635d7b9.png";